module.exports = __webpack_public_path__ + "static/img/bg.ee92a3c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg.jpg
// module id = 1225
// module chunks = 1